export async function speeroCode(growthbookInstance) {
  if (process.client && growthbookInstance) {
    if (growthbookInstance.isOn('aa')) {
      console.debug('AA test');
    }
  }
}
